import React from "react";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import {
  CmpDatePicker,
} from "../../../Component/Common/ToolBox/ToolBox";

const HeaderComponent = ({
  handleLoadBtn = () => {},
  filterObj,
  setFilterObj,
  handlePrint,
  handleExport,
  LocationData,
  vMediaQuery
}) => {
  // Media Queries for Responsiveness
  const isMobile = useMediaQuery("(max-width:600px)");


  return (
    <div className="stock-detail">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={2.4} md={2}>
          <Typography>From Date</Typography>
          <CmpDatePicker
            xValue={filterObj?.dateFrom}
            xOnChange={(newValue) =>
              setFilterObj((obj) => ({
                ...obj,
                dateFrom: newValue?.$d ?? newValue,
              }))
            }
            xName={"dateFrom"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item xs={12} sm={2.4} md={2}>
          <Typography>To Date</Typography>
          <CmpDatePicker
            style={{ width: "100% !important" }}
            xValue={filterObj?.dateTo}
            xOnChange={(newValue) =>
              setFilterObj((obj) => ({
                ...obj,
                dateTo: newValue?.$d ?? newValue,
              }))
            }
            xName={"dateTo"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <Typography>Location</Typography>
          <FormControl fullWidth>
            <Select
              value={filterObj?.Loc}
              name="Location"
              onChange={(event) =>
                setFilterObj((prev) => ({
                  ...prev,
                  Loc: event.target.value,
                }))
              }
            >
              {LocationData?.map((loc) => (
                <MenuItem key={loc.UId} value={loc.UId}>
                  {loc.Name1}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          item
          xs={12}
          sm={2.2}
          md={2}
        >
          <FormControlLabel
             sx={{ mt:vMediaQuery? 0: 2, "& .MuiFormControlLabel-label": { fontSize: "12px" } }}
            control={
              <Checkbox
                checked={filterObj.DC_Purchase === "Y"} // ✅ now it's defined
                onChange={(event) =>
                  setFilterObj((prev) => ({
                    ...prev,
                    DC_Purchase: event.target.checked ? "Y" : "N",
                  }))
                }
                color="primary"
              />
            }
            label="Market"
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={2}
          md={4}
          display={"flex"}
          justifyContent={isMobile ? "center" : "flex-end"}
          alignItems={"flex-end"}
          gap={1}
        >
          <Button variant="contained" size="small" onClick={handleLoadBtn}>
            load
          </Button>
          <Tooltip title="Export CSV">
            <IconButton color="primary" onClick={handleExport} size="small">
              <DownloadOutlinedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Print">
            <IconButton color="primary" onClick={handlePrint} size="small">
              <PrintOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
    </div>
  );
};

export default HeaderComponent;
